"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useInView;
var _react = require("react");
// Using a callback makes it easier to pass down a ref as a prop

function useInView(setState) {
  var ref = (0, _react.useRef)(null);
  var refCallback = (0, _react.useCallback)(function (node) {
    if (ref.current) ref.current.disconnect();
    ref.current = new IntersectionObserver(function (entries) {
      setState(entries[0].isIntersecting);
    });
    if (node) ref.current.observe(node);
  }, []);
  return refCallback;
}